import classNames from "classnames"
import React from "react"

import "./PageContent.scss"
import { useSetPageBackground } from "~/hooks/useSetPageBackground"

type PageContentProps = {
  className?: string
  style?: "dark" | "light"
  center?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export default function PageContent(props: PageContentProps) {
  const { className, style = "dark", center = true, ...rest } = props

  useSetPageBackground(style === "dark" ? "var(--primary)" : null)

  const usedClassName = classNames(
    "PageContent",
    `PageContent--${style}`,
    {
      "PageContent--center": center,
    },
    className,
  )

  return <div className={usedClassName} {...rest} />
}
